<script setup lang="ts">
import type { CommandItemBaseProps } from "./types";
import { MinusIcon } from "lucide-vue-next";
import SuggestionListItem from "../suggestions/SuggestionListItem.vue";

const props = defineProps<CommandItemBaseProps>();

function run() {
  props.editor
    .chain()
    .focus()
    .deleteRange(props.range)
    .insertBelow(({ escapeList: true, onlyIfEmpty: true }))
    .selectNodeBackward() // in case of escapeList:false we should avoid of selecting previous node
    .setHorizontalRule()
    .run();
}

defineExpose({ run });
</script>

<template>
  <SuggestionListItem
    :icon="MinusIcon"
    shortcut="---"
    @click="run"
    @keydown.enter="run"
  >
    Divider
  </SuggestionListItem>
</template>
